<template>
  <section  :class="teams.theme">
    <textarea v-if="showLog" v-model="user.loginfo" style="width: 100%; height: 300px;"></textarea>
    <div v-if="isHelp">
      <div class="not-authenticated">
        <div id="wrapper">
          <div id="page-content">
            <router-view id="main-content"></router-view>
          </div>
        </div>
      </div>
    </div>
    <div class="float-right" v-if="showLogInfo"><i @click="showLog = !showLog" class="fa-light fa-angle-down"></i></div>        
    <ErrorValidations_4_4></ErrorValidations_4_4>
    <OutOfOffice_4_4 v-if="user.information"></OutOfOffice_4_4>
    <div v-if="!isHelp && teams.context">      
      <div v-if="!teams.authenticated">
        <div class="not-authenticated">
          <div id="wrapper">
            <div id="page-content">
              <WaitingForGraphAuthentication id="main-content"></WaitingForGraphAuthentication>
            </div>
          </div>
        </div>
      </div>
      <div v-if="teams.authenticated">
        <div
        :key="teamsKey"
        v-bind:class="{
          authenticated: user.information,
          'not-authenticated': !user.information,
        }"
          v-if="user.hostname"
          >
          <b-alert variant="success" class="m-0" show v-if="user.notification_text" v-html="user.notification_text"></b-alert>    
          <div id="wrapper" v-if="user.information">                 
            <TimeOut></TimeOut>
            <div id="page-content" v-bind:class="{ transparent: isTransparent }">           
              <Navbar @gotoLink="gotoLink" class="no-print"></Navbar>
              <router-view :key="appKey" id="main-content"></router-view>
            </div>
          </div>
          <div id="wrapper" v-if="!user.information">
            <div id="page-content">
              <router-view id="main-content"></router-view>
            </div>
          </div>
        </div>
        <div class="not-authenticated" v-if="user.notregistered">
          <div id="wrapper">
            <div id="page-content">
              <NotRegisteredInSefos id="main-content"></NotRegisteredInSefos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import teamsMethods from "@/mixins/teamsMethods";
import Navbar from "@/components/Layout/Navbar";
import WaitingForGraphAuthentication from "@/components/Layout/WaitingForGraphAuthentication";
import NotRegisteredInSefos from "@/components/Layout/NotRegisteredInSefos";
import TimeOut from "@/components/TimeOut";
import ErrorValidations_4_4 from "@/components_4_4/ErrorValidations";
import OutOfOffice_4_4 from "@/components_4_4/OutOfOffice";
export default {
  mixins: [teamsMethods],
  components: { Navbar, NotRegisteredInSefos, WaitingForGraphAuthentication, TimeOut, ErrorValidations_4_4, OutOfOffice_4_4 },
  data() {
    return {
      checkAuth: 0,
      teamsIndex: 0,
      appIndex: 0,
      context: {},
      isHelp: false,
      showLog: false
    };
  },
  methods: {
    gotoLink(){
      this.appIndex++;
    },
    async checkAuthenticated(){
      let self = this;
      console.log("checkAuthenticated");
      setTimeout(async function(){ 
        self.$store.dispatch("user/logInfo", "checkAuthenticated");        
        console.log("checkAuthenticated1");
        await self.$store.dispatch("user/fetchUser");
      }, 1000);      
      setTimeout(async function(){ 
          self.$store.dispatch("user/logInfo", "checkAuthenticated");  
          console.log("checkAuthenticated2");      
          await self.$store.dispatch("user/fetchUser");
      }, 2000);      
      setTimeout(async function(){ 
          self.$store.dispatch("user/logInfo", "checkAuthenticated"); 
          console.log("checkAuthenticated3");       
          await self.$store.dispatch("user/fetchUser");
      }, 3000);
    },
    async initTeams() {
      try {
        await this.microsoftTeams.app.initialize();
        await this.microsoftTeams.app.notifySuccess();
      } catch (e) {
        console.error("Teams init failed", e);
      }
    },
    logoutAction() {
      this.$store.dispatch("user/NotAuthenticated");
      localStorage.removeItem("token");
      this.$router.push({ name: "Login" });
    },
    async init() {      
      if (localStorage.getItem("token") != null) {
        this.$store.dispatch("user/setToken", localStorage.getItem("token"));
      }
      await this.$store.dispatch("user/logInfo", "init");
      await this.initTeams();
      await this.teamsCheckAuthenticated(false);      
      await this.checkAuthenticated();  
    },
    changeTheme(theme)
    {
      document.getElementsByTagName('body')[0].style.display = 'none';
      let styleLink = document.getElementById('syncfusion-css');
      if(theme == "theme-default")
      {
        styleLink.href = '/css/syncfusion/bootstrap5.css';
      }
      if(theme == "theme-dark")
      {
        styleLink.href = '/css/syncfusion/bootstrap5-dark.css';
      }
      if(theme == "theme-contrast")
      {
        styleLink.href = '/css/syncfusion/highcontrast.css';
      }
      setTimeout(function () { document.getElementsByTagName('body')[0].style.display = 'block'; }, 250);
    }
  },
  computed: {
    showLogInfo(){      
      return !this.user.information;
    },
    teamsKey(){
      return "teamsKey_" + this.teamsIndex;
    },    
    appKey(){
      return "appKey" + this.appIndex;
    },
    isTransparent() {
      return this.$route.path == "/dashboard";
    }
  },
  watch: {
    locale: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.teamsIndex++;
        this.$i18n.locale = newVal;
      }
    },
    "teams.context": function(newVal, oldVal) {
      if (newVal != oldVal && newVal != undefined) {        
        if(newVal.app.locale != undefined)
        {
          let lang = newVal.app.locale.split("-")[0];
          console.log("Teams locale: " + lang);
          switch (lang)
          {
            case "sv": 
              this.$i18n.locale = "sv";
              this.$store.dispatch("lang/setLocale", "sv");    
              break;
            case "nb":
            case "no":
            case "nn": 
              this.$i18n.locale = "nb";
              this.$store.dispatch("lang/setLocale", "nb");
              break;
            default: 
              this.$i18n.locale = "en";
              this.$store.dispatch("lang/setLocale", "en");
              break;
          }          
        }else{
          console.log("Locale undefined using swedish");
          this.$i18n.locale = "sv";
          this.$store.dispatch("lang/setLocale", "sv");
        }
      }
    },
    "teams.theme": function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.changeTheme(newVal);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
2
